import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import {useTranslation} from 'react-i18next';
import {localizePath} from '@/i18n';
import styles from '@/views/Layout/Public/LangMenu.module.css';

import {SystemConfigCtx} from '@/contexts';
import {blank} from '@/util';

const LangMenu = ({location}) => {
  const to = localizePath(location);
  const {t: tr, i18n} = useTranslation();
  const currentLang = i18n.language;
  const {siteCode} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  const colorClass = {
    afs: styles.langAfs,
    ipc: styles.langIpc,
  };

  return (
    <div className={`${styles.lang} ${colorClass[siteCode]}`}>
      {siteCode === 'afs' && (
        <>
          <Link
            to={to('en')}
            className={currentLang === 'en' ? `${styles.active}` : ''}
          >
            <span>{tr('language.en')}</span>
          </Link>
          <Link
            to={to('zh')}
            className={currentLang === 'zh' ? `${styles.active}` : ''}
          >
            <span>{tr('language.zh')}</span>
          </Link>
          <Link
            to={to('ja')}
            className={currentLang === 'ja' ? `${styles.active}` : ''}
          >
            <span>{tr('language.ja')}</span>
          </Link>
          <Link
            to={to('kr')}
            className={currentLang === 'kr' ? `${styles.active}` : ''}
          >
            <span>{tr('language.kr')}</span>
          </Link>
        </>
      )}
      {siteCode === 'ipc' && (
        <>
          <Link
            to={to('en')}
            className={currentLang === 'en' ? `${styles.active}` : ''}
          >
            <span>{tr('language.en')}</span>
          </Link>
          <Link
            to={to('zh')}
            className={currentLang === 'zh' ? `${styles.active}` : ''}
          >
            <span>{tr('language.zh')}</span>
          </Link>
        </>
      )}
    </div>
  );
};

export default withRouter(LangMenu);
